import { render, staticRenderFns } from "./ChannelAddDialog.vue?vue&type=template&id=e55744cc"
import script from "./ChannelAddDialog.vue?vue&type=script&lang=js"
export * from "./ChannelAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports